export type RequestForQuoteEmptyStateSituation = {
  isQuotesTab: boolean;
  isFiltered: boolean;
  areArchivedRequestsHidden: boolean;
  hasSentRequests: boolean | undefined;
};

export type RequestForQuoteEmptyStateKey =
  | 'my_requests_for_quote.filtered_archived_hidden'
  | 'my_requests_for_quote.filtered_empty'
  | 'my_requests_for_quote.archived_hidden'
  | 'my_requests_for_quote.nothing_to_show'
  | 'my_requests_for_quote.no_requests'
  | 'my_requests_for_quote.none_answered'
  | 'my_requests_for_quote.none_waiting';

const EMPTY_STATE_PRECEDENCE: ReadonlyArray<{
  key: RequestForQuoteEmptyStateKey;
  appliesTo: (situation: RequestForQuoteEmptyStateSituation) => boolean;
}> = [
  {
    key: 'my_requests_for_quote.filtered_archived_hidden',
    appliesTo: (situation) =>
      situation.isFiltered && situation.areArchivedRequestsHidden,
  },
  {
    key: 'my_requests_for_quote.filtered_empty',
    appliesTo: (situation) => situation.isFiltered,
  },
  {
    key: 'my_requests_for_quote.archived_hidden',
    appliesTo: (situation) => situation.areArchivedRequestsHidden,
  },
  {
    key: 'my_requests_for_quote.nothing_to_show',
    appliesTo: (situation) => situation.hasSentRequests === undefined,
  },
  {
    key: 'my_requests_for_quote.no_requests',
    appliesTo: (situation) => situation.hasSentRequests === false,
  },
  {
    key: 'my_requests_for_quote.none_answered',
    appliesTo: (situation) => situation.isQuotesTab,
  },
];

export function requestForQuoteEmptyStateKey(
  situation: RequestForQuoteEmptyStateSituation
): RequestForQuoteEmptyStateKey {
  return (
    EMPTY_STATE_PRECEDENCE.find((emptyState) => emptyState.appliesTo(situation))
      ?.key ?? 'my_requests_for_quote.none_waiting'
  );
}
